import * as Atdgen_codec_runtime from "@ahrefs/bs-atdgen-codec-runtime/src/atdgen_codec_runtime.bs.js";
import * as Dtype_wrap$SolvuuApi0 from "./dtype_wrap.bs.js";
import * as Int_array_wrap$SolvuuApi0 from "./int_array_wrap.bs.js";
import * as Bigdata_strings_bs$SolvuuApi0 from "./bigdata_strings_bs.bs.js";
var write_strings = Atdgen_codec_runtime.Encode.make(function (x) {
  if (x[0] >= -83649777) {
    return Atdgen_codec_runtime.Encode.constr1("String_matrix", Bigdata_strings_bs$SolvuuApi0.write_string_matrix, x[1]);
  } else {
    return Atdgen_codec_runtime.Encode.constr1("String_array", Bigdata_strings_bs$SolvuuApi0.write_string_array, x[1]);
  }
});
var read_strings = Atdgen_codec_runtime.Decode.$$enum(
/* :: */
[
/* tuple */
["String_array",
/* `Decode */
[427938126, function (param) {
  return Atdgen_codec_runtime.Decode.map(function (x) {
    return (
      /* `String_array */
      [-867361653, x]
    );
  }, Bigdata_strings_bs$SolvuuApi0.read_string_array, param);
}]],
/* :: */
[
/* tuple */
["String_matrix",
/* `Decode */
[427938126, function (param) {
  return Atdgen_codec_runtime.Decode.map(function (x) {
    return (
      /* `String_matrix */
      [-83649777, x]
    );
  }, Bigdata_strings_bs$SolvuuApi0.read_string_matrix, param);
}]],
/* [] */
0]]);

function write_t$prime(write__int32_genarray, write__int64_genarray, write__float32_genarray, write__float64_genarray) {
  return Atdgen_codec_runtime.Encode.make(function (x) {
    var variant = x[0];

    if (variant !== -714735238) {
      if (variant >= 28091885) {
        if (variant >= 81581934) {
          return Atdgen_codec_runtime.Encode.constr1("Float64_genarray", write__float64_genarray, x[1]);
        } else {
          return Atdgen_codec_runtime.Encode.constr1("Float32_genarray", write__float32_genarray, x[1]);
        }
      } else if (variant >= -661245189) {
        return Atdgen_codec_runtime.Encode.constr1("Int64_genarray", write__int64_genarray, x[1]);
      } else {
        return Atdgen_codec_runtime.Encode.constr1("Strings", write_strings, x[1]);
      }
    } else {
      return Atdgen_codec_runtime.Encode.constr1("Int32_genarray", write__int32_genarray, x[1]);
    }
  });
}

function read_t$prime(read__int32_genarray, read__int64_genarray, read__float32_genarray, read__float64_genarray) {
  return Atdgen_codec_runtime.Decode.$$enum(
  /* :: */
  [
  /* tuple */
  ["Strings",
  /* `Decode */
  [427938126, function (param) {
    return Atdgen_codec_runtime.Decode.map(function (x) {
      return (
        /* `Strings */
        [-968575390, x]
      );
    }, read_strings, param);
  }]],
  /* :: */
  [
  /* tuple */
  ["Float32_genarray",
  /* `Decode */
  [427938126, function (param) {
    return Atdgen_codec_runtime.Decode.map(function (x) {
      return (
        /* `Float32_genarray */
        [28091885, x]
      );
    }, read__float32_genarray, param);
  }]],
  /* :: */
  [
  /* tuple */
  ["Float64_genarray",
  /* `Decode */
  [427938126, function (param) {
    return Atdgen_codec_runtime.Decode.map(function (x) {
      return (
        /* `Float64_genarray */
        [81581934, x]
      );
    }, read__float64_genarray, param);
  }]],
  /* :: */
  [
  /* tuple */
  ["Int32_genarray",
  /* `Decode */
  [427938126, function (param) {
    return Atdgen_codec_runtime.Decode.map(function (x) {
      return (
        /* `Int32_genarray */
        [-714735238, x]
      );
    }, read__int32_genarray, param);
  }]],
  /* :: */
  [
  /* tuple */
  ["Int64_genarray",
  /* `Decode */
  [427938126, function (param) {
    return Atdgen_codec_runtime.Decode.map(function (x) {
      return (
        /* `Int64_genarray */
        [-661245189, x]
      );
    }, read__int64_genarray, param);
  }]],
  /* [] */
  0]]]]]);
}

var write_strings_term = Atdgen_codec_runtime.Encode.make(function (x) {
  return Atdgen_codec_runtime.Encode.constr1("Strings", write_strings, x[1]);
});
var read_strings_term = Atdgen_codec_runtime.Decode.$$enum(
/* :: */
[
/* tuple */
["Strings",
/* `Decode */
[427938126, function (param) {
  return Atdgen_codec_runtime.Decode.map(function (x) {
    return (
      /* `Strings */
      [-968575390, x]
    );
  }, read_strings, param);
}]],
/* [] */
0]);

function write_numeric$prime(write__int32_genarray, write__int64_genarray, write__float32_genarray, write__float64_genarray) {
  return Atdgen_codec_runtime.Encode.make(function (x) {
    var variant = x[0];

    if (variant >= 28091885) {
      if (variant >= 81581934) {
        return Atdgen_codec_runtime.Encode.constr1("Float64_genarray", write__float64_genarray, x[1]);
      } else {
        return Atdgen_codec_runtime.Encode.constr1("Float32_genarray", write__float32_genarray, x[1]);
      }
    } else if (variant >= -661245189) {
      return Atdgen_codec_runtime.Encode.constr1("Int64_genarray", write__int64_genarray, x[1]);
    } else {
      return Atdgen_codec_runtime.Encode.constr1("Int32_genarray", write__int32_genarray, x[1]);
    }
  });
}

function read_numeric$prime(read__int32_genarray, read__int64_genarray, read__float32_genarray, read__float64_genarray) {
  return Atdgen_codec_runtime.Decode.$$enum(
  /* :: */
  [
  /* tuple */
  ["Float32_genarray",
  /* `Decode */
  [427938126, function (param) {
    return Atdgen_codec_runtime.Decode.map(function (x) {
      return (
        /* `Float32_genarray */
        [28091885, x]
      );
    }, read__float32_genarray, param);
  }]],
  /* :: */
  [
  /* tuple */
  ["Float64_genarray",
  /* `Decode */
  [427938126, function (param) {
    return Atdgen_codec_runtime.Decode.map(function (x) {
      return (
        /* `Float64_genarray */
        [81581934, x]
      );
    }, read__float64_genarray, param);
  }]],
  /* :: */
  [
  /* tuple */
  ["Int32_genarray",
  /* `Decode */
  [427938126, function (param) {
    return Atdgen_codec_runtime.Decode.map(function (x) {
      return (
        /* `Int32_genarray */
        [-714735238, x]
      );
    }, read__int32_genarray, param);
  }]],
  /* :: */
  [
  /* tuple */
  ["Int64_genarray",
  /* `Decode */
  [427938126, function (param) {
    return Atdgen_codec_runtime.Decode.map(function (x) {
      return (
        /* `Int64_genarray */
        [-661245189, x]
      );
    }, read__int64_genarray, param);
  }]],
  /* [] */
  0]]]]);
}

function write__2(param) {
  return Atdgen_codec_runtime.Encode.list(Atdgen_codec_runtime.Encode.$$int, param);
}

function read__2(param) {
  return Atdgen_codec_runtime.Decode.list(Atdgen_codec_runtime.Decode.$$int, param);
}

function write__3(param) {
  return Atdgen_codec_runtime.Encode.contramap(Int_array_wrap$SolvuuApi0.unwrap, write__2, param);
}

function read__3(param) {
  return Atdgen_codec_runtime.Decode.map(Int_array_wrap$SolvuuApi0.wrap, read__2, param);
}

function write__1(param) {
  return Atdgen_codec_runtime.Encode.contramap(Dtype_wrap$SolvuuApi0.unwrap, Atdgen_codec_runtime.Encode.string, param);
}

function read__1(param) {
  return Atdgen_codec_runtime.Decode.map(Dtype_wrap$SolvuuApi0.wrap, Atdgen_codec_runtime.Decode.string, param);
}

function write_ndarray(write__a) {
  return Atdgen_codec_runtime.Encode.make(function (t) {
    return Atdgen_codec_runtime.Encode.obj(
    /* :: */
    [Atdgen_codec_runtime.Encode.field(undefined, write__3, "shape", t.shape),
    /* :: */
    [Atdgen_codec_runtime.Encode.field(undefined, write__1, "dtype", t.dtype),
    /* :: */
    [Atdgen_codec_runtime.Encode.field(undefined, Atdgen_codec_runtime.Encode.$$int, "size", t.size),
    /* :: */
    [Atdgen_codec_runtime.Encode.field(undefined, Atdgen_codec_runtime.Encode.$$int, "dimension", t.dimension),
    /* :: */
    [Atdgen_codec_runtime.Encode.field(undefined, Atdgen_codec_runtime.Encode.$$int, "offset", t.offset),
    /* :: */
    [Atdgen_codec_runtime.Encode.field(undefined, write__3, "stride", t.stride),
    /* :: */
    [Atdgen_codec_runtime.Encode.field(undefined, write__3, "order", t.order),
    /* :: */
    [Atdgen_codec_runtime.Encode.field(undefined, write__a, "data", t.data),
    /* [] */
    0]]]]]]]]);
  });
}

function read_ndarray(read__a) {
  return Atdgen_codec_runtime.Decode.make(function (json) {
    return {
      shape: Atdgen_codec_runtime.Decode.decode(function (param) {
        return Atdgen_codec_runtime.Decode.field("shape", read__3, param);
      }, json),
      dtype: Atdgen_codec_runtime.Decode.decode(function (param) {
        return Atdgen_codec_runtime.Decode.field("dtype", read__1, param);
      }, json),
      size: Atdgen_codec_runtime.Decode.decode(function (param) {
        return Atdgen_codec_runtime.Decode.field("size", Atdgen_codec_runtime.Decode.$$int, param);
      }, json),
      dimension: Atdgen_codec_runtime.Decode.decode(function (param) {
        return Atdgen_codec_runtime.Decode.field("dimension", Atdgen_codec_runtime.Decode.$$int, param);
      }, json),
      offset: Atdgen_codec_runtime.Decode.decode(function (param) {
        return Atdgen_codec_runtime.Decode.field("offset", Atdgen_codec_runtime.Decode.$$int, param);
      }, json),
      stride: Atdgen_codec_runtime.Decode.decode(function (param) {
        return Atdgen_codec_runtime.Decode.field("stride", read__3, param);
      }, json),
      order: Atdgen_codec_runtime.Decode.decode(function (param) {
        return Atdgen_codec_runtime.Decode.field("order", read__3, param);
      }, json),
      data: Atdgen_codec_runtime.Decode.decode(function (param) {
        return Atdgen_codec_runtime.Decode.field("data", read__a, param);
      }, json)
    };
  });
}

function write_ints$prime(write__int32_genarray, write__int64_genarray) {
  return Atdgen_codec_runtime.Encode.make(function (x) {
    if (x[0] >= -661245189) {
      return Atdgen_codec_runtime.Encode.constr1("Int64_genarray", write__int64_genarray, x[1]);
    } else {
      return Atdgen_codec_runtime.Encode.constr1("Int32_genarray", write__int32_genarray, x[1]);
    }
  });
}

function read_ints$prime(read__int32_genarray, read__int64_genarray) {
  return Atdgen_codec_runtime.Decode.$$enum(
  /* :: */
  [
  /* tuple */
  ["Int32_genarray",
  /* `Decode */
  [427938126, function (param) {
    return Atdgen_codec_runtime.Decode.map(function (x) {
      return (
        /* `Int32_genarray */
        [-714735238, x]
      );
    }, read__int32_genarray, param);
  }]],
  /* :: */
  [
  /* tuple */
  ["Int64_genarray",
  /* `Decode */
  [427938126, function (param) {
    return Atdgen_codec_runtime.Decode.map(function (x) {
      return (
        /* `Int64_genarray */
        [-661245189, x]
      );
    }, read__int64_genarray, param);
  }]],
  /* [] */
  0]]);
}

function write_floats$prime(write__float32_genarray, write__float64_genarray) {
  return Atdgen_codec_runtime.Encode.make(function (x) {
    if (x[0] >= 81581934) {
      return Atdgen_codec_runtime.Encode.constr1("Float64_genarray", write__float64_genarray, x[1]);
    } else {
      return Atdgen_codec_runtime.Encode.constr1("Float32_genarray", write__float32_genarray, x[1]);
    }
  });
}

function read_floats$prime(read__float32_genarray, read__float64_genarray) {
  return Atdgen_codec_runtime.Decode.$$enum(
  /* :: */
  [
  /* tuple */
  ["Float32_genarray",
  /* `Decode */
  [427938126, function (param) {
    return Atdgen_codec_runtime.Decode.map(function (x) {
      return (
        /* `Float32_genarray */
        [28091885, x]
      );
    }, read__float32_genarray, param);
  }]],
  /* :: */
  [
  /* tuple */
  ["Float64_genarray",
  /* `Decode */
  [427938126, function (param) {
    return Atdgen_codec_runtime.Decode.map(function (x) {
      return (
        /* `Float64_genarray */
        [81581934, x]
      );
    }, read__float64_genarray, param);
  }]],
  /* [] */
  0]]);
}

var read_string_matrix = Bigdata_strings_bs$SolvuuApi0.read_string_matrix;
var write_string_matrix = Bigdata_strings_bs$SolvuuApi0.write_string_matrix;
var read_string_array = Bigdata_strings_bs$SolvuuApi0.read_string_array;
var write_string_array = Bigdata_strings_bs$SolvuuApi0.write_string_array;
var read_int_array = read__3;
var write_int_array = write__3;
var read_dtype = read__1;
var write_dtype = write__1;
export { read_string_matrix, write_string_matrix, read_string_array, write_string_array, read_strings, write_strings, read_t$prime, write_t$prime, read_strings_term, write_strings_term, read_numeric$prime, write_numeric$prime, read_int_array, write_int_array, read_dtype, write_dtype, read_ndarray, write_ndarray, read_ints$prime, write_ints$prime, read_floats$prime, write_floats$prime };
/* write_strings Not a pure module */